module.exports = __webpack_public_path__ + "static/vid-1d108e0e29237794cbf847e80dfe9acc.mp4";